<template>
    <div>
        <div class="image-section">
            <img src="@/assets/yejslib1.jpg"  class="product-image">
            <img src="@/assets/yejslib2.jpg"  class="product-image">
            <img src="@/assets/yejslib3.jpg"  class="product-image">
            <img src="@/assets/yejslib4.jpg"  class="product-image">
            <img src="@/assets/yejslib5.jpg"  class="product-image">
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.image-section{
    display: flex;
    flex-direction: column;
    margin-top: 60px;
    align-items: center
}
.product-image{
    width: 1000px;
    height: 1000px;
}
</style>
